module.exports = __webpack_public_path__ + "static/media/colabs-portfolio_03.0e88605e.jpg";